import React from 'react';

const Arrow = () => {
  return (
    <svg
      version="1.1"
      id="arrow_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 240.82 240.82"
      style="enable-background:new 0 0 240.82 240.82;"
      space="preserve"
      style={{
        fill: 'currentColor',
        strokeWidth: 3,
        strokeMiterlimit: 10,
        verticalAlign: 'middle',
      }}
    >
      <g>
        <path d="M178.73,112.43L78.13,11.86c-4.41-4.4-11.57-4.4-15.99,0c-4.41,4.4-4.41,11.56,0,15.96 		l92.62,92.59L62.14,213c-4.41,4.4-4.41, 1.56,0,15.97c4.41,4.4,11.58,4.4,15.99,0l100.6-100.57 C183.09,124.04,183.09,116.77,178.73,112.43z" />
      </g>
    </svg>
  );
};

export default Arrow;
